package com.trevorwiebe.timesheet.mileage.presentation

import com.trevorwiebe.timesheet.mileage.domain.model.TripType
import com.trevorwiebe.timesheet.mileage.domain.model.displayLabel

/**
 * Entry-form trip-type picker options. Declaration order = chip order on all platforms.
 * START_DAY and END_DAY are cosmetic aliases that both save [TripType.START_END].
 */
enum class TripTypeOption(val tripType: TripType) {
    LOADING(TripType.LOADING),
    UNLOADING(TripType.UNLOADING),
    START_DAY(TripType.START_END),
    END_DAY(TripType.START_END),
    FUEL(TripType.FUEL),
    STATE_LINE(TripType.STATE_LINE),
    SERVICE(TripType.SERVICE),
    OTHER(TripType.OTHER);

    fun displayLabel(): String = when (this) {
        START_DAY -> "Start"
        END_DAY -> "End"
        else -> tripType.displayLabel()
    }

    companion object {
        /** START_END maps to START_DAY (deterministic when editing existing entries). */
        fun fromTripType(type: TripType): TripTypeOption = entries.first { it.tripType == type }
    }
}
